import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. Uvezi hook
import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';
import MioProfilo from '../../components/MioProfilo';
import Icon from '../../components/AppIcon';
import QrCodeDipendente from '../../components/QrCodeDipendente';
import MojeTimbrature from 'components/navigation/MojeTimbrature';
import { supabase } from '../../lib/supabase';

const ProfiloPage = () => {
  const { t } = useTranslation(); // 2. Inicijalizuj
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const { data: { user } } = await supabase.auth.getUser();
        
        if (user) {
          const { data: profile, error } = await supabase
            .from('profili')
            .select('*')
            .eq('id', user.id)
            .single();
          
          if (error) throw error;
          setUserData(profile);
        }
      } catch (err) {
        console.error("Error fetching profile:", err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchUser();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <MobileMenuButton isOpen={isSidebarOpen} onClick={() => setIsSidebarOpen(!isSidebarOpen)} />
      <DashboardSidebar isCollapsed={!isSidebarOpen} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
      
      {/* Koristimo t() za naslov u headeru */}
      <DashboardHeader userName={t('profile_page.title')} />

      <main className="main-content with-sidebar py-10 px-4 mt-20">
        <div className="max-w-5xl mx-auto">
          
     {/* Dugmad — nazad + My Holidays + QR */}
<div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
  
  {/* Nazad */}
  <button 
    onClick={() => navigate(-1)} 
    className="group flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors font-bold uppercase text-[10px] tracking-widest"
  >
    <div className="p-2 bg-muted rounded-xl group-hover:bg-primary/10 transition-colors">
      <Icon name="ArrowLeft" size={16} />
    </div>
    {t('profile_page.back')}
  </button>

  {/* Desna strana — My Holidays + QR */}
  {!loading && userData && (
    <div className="flex items-center gap-3 flex-wrap sm:flex-nowrap">
      
      {/* MY HOLIDAYS dugme */}
      <button 
        onClick={() => navigate('/my-holidays')}
        className="flex items-center justify-center gap-2 bg-card border border-border px-6 py-3 rounded-2xl hover:border-primary/50 transition-all group shadow-sm w-full sm:w-auto"
      >
        <div className="text-primary group-hover:scale-110 transition-transform">
          <Icon name="Palmtree" size={20} />
        </div>
        <span className="font-black uppercase text-[10px] tracking-widest text-foreground">
          {t('profile_page.my_holidays')}
        </span>
      </button>

      {/* QR Badge dugme */}
      <button 
        onClick={() => setIsQrModalOpen(true)}
        className="flex items-center justify-center gap-2 bg-card border border-border px-6 py-3 rounded-2xl hover:border-primary/50 transition-all group shadow-sm w-full sm:w-auto"
      >
        <div className="text-primary group-hover:scale-110 transition-transform">
          <Icon name="QrCode" size={20} />
        </div>
        <span className="font-black uppercase text-[10px] tracking-widest text-foreground">
          {t('profile_page.qr_badge')}
        </span>
      </button>

    </div>
  )}
</div>

          <div className="mb-10">
            <div className="h-1 w-20 bg-primary mt-2 rounded-full"></div>
          </div>
          
          <MioProfilo />

          {!loading && userData?.id ? (
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200">
               <MojeTimbrature userId={userData.id} />
            </div>
          ) : (
            <div className="flex justify-center py-10">
               <Icon name="Loader2" size={24} className="animate-spin text-primary/50" />
            </div>
          )}
          
        </div>
      </main>

      {userData && (
        <QrCodeDipendente 
          isOpen={isQrModalOpen} 
          onClose={() => setIsQrModalOpen(false)} 
          data={userData} 
        />
      )}

      <DashboardFooter />
    </div>
  );
};

export default ProfiloPage;